// src/utils/slugify.js
export const createSlug = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_]+/g, '-')  // Replace spaces and underscores with hyphens
    .replace(/-+/g, '-')      // Replace multiple hyphens with single
    .replace(/^-+|-+$/g, ''); // Trim hyphens from start and end
};

export const findShowBySlug = (shows, slug) => {
  return shows.findIndex(show => createSlug(show.title) === slug);
};

export const findEpisodeBySlug = (episodes, slug) => {
  return episodes.findIndex(episode => createSlug(episode.title) === slug);
};